import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Page tracker — envia um beacon para /api/analytics/page-visit a cada mudança
 * de rota. Fire-and-forget, silencioso em erros. Genérico: usado no MY e no
 * Media Center (o CRM e o Admin NÃO são rastreados).
 *
 * `source` etiqueta a app de origem ("my" | "media"). Envia também o cookie
 * `ihtp_vid` (partilhado em .ihavethepower.net) como visitor_id, permitindo o
 * identity stitching com as visitas anónimas do site WordPress.
 */
function getCookie(n) {
  const m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
  return m ? m.pop() : '';
}

export default function PageTracker({ source }) {
  const location = useLocation();
  const last = useRef(null);

  useEffect(() => {
    const path = location.pathname + (location.search || '');
    if (last.current === path) return;
    last.current = path;
    const API = process.env.REACT_APP_BACKEND_URL || '';
    const vid = getCookie('ihtp_vid') || undefined;
    try {
      fetch(`${API}/api/analytics/page-visit`, {
        method: 'POST',
        credentials: 'include',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ path, title: document.title || '', visitor_id: vid, app: source }),
      }).catch(() => {});
    } catch (e) { /* noop */ }
  }, [location.pathname, location.search, source]);

  return null;
}
